module.exports = __webpack_public_path__ + "static/media/people-laptops.9e9eb517.png";